import {flow, getEnv, types} from "mobx-state-tree";
import Notification from "../../../../utils/Notification";

const DeleteRuleSetState = types.model('DeleteRuleSetState', {
  formHasErrors: types.optional(types.boolean, false),
  errorMessage: types.optional(types.string, ""),
  title: types.maybe(types.string),
  uuid: types.maybe(types.string)
})
  .volatile(self => ({
    toggleModal: types.fn,
    refreshList: types.fn,
  }))
  .actions((self) => ({
    handleHasDeleteErrors(boolean) {
      self.formHasErrors = boolean
    },
    handleDeleteErrorMessage(message) {
      self.errorMessage = message
    },
    setToggleListener(listener) {
      self.toggleModal = listener
    },
    setRefreshListener(listener) {
      self.refreshList = listener
    },
    setDeleteRuleSetListener(fn) {
      self.deleteRuleCallBack = fn
    },
    notifyDeleteRuleCallBack(uuid) {
      self.deleteRuleCallBack(uuid)
    },

    deleteRuleSet: flow(function* () {

      const manager = getEnv(self).ruleSetManager;
      const resp = yield manager.delete(self)
      if(resp){
        self.deleteRuleCallBack(self.uuid)
      }

      !self.formHasErrors && new Notification()
        .setType("success")
        .setMessage(`${self.title} Rule Set deleted`)
        .send();
      !self.formHasErrors && self.refreshList()
      !self.formHasErrors && self.toggleModal()
    }),

  }))

export default DeleteRuleSetState;
